import styled from 'styled-components';

export const DragAndDropWrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    &.is-disabled {
        background: ${(props) => props.theme.palette.secondaryA9};
    }
`;
